import { render, staticRenderFns } from "./WyhSettingIndex.vue?vue&type=template&id=c997e362&scoped=true&"
import script from "./WyhSettingIndex.vue?vue&type=script&lang=js&"
export * from "./WyhSettingIndex.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingIndex.vue?vue&type=style&index=0&id=c997e362&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c997e362",
  null
  
)

export default component.exports